// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"560":"e45017c6","680":"6faac415"}[chunkId] + ".chunk.js";
};